export enum ComplianceAnswerOption {
  unset = 'UNSET',
  passed = 'PASSED',
  notPassed = 'NOT_PASSED',
  notApplicable = 'NOT_APPLICABLE',
}